import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import {i18n} from 'src/i18n';

export default [
  {
    name: 'label',
    label: i18n('entities.documentCategory.fields.label'),
    schema: schemas.string(i18n('entities.documentCategory.fields.label'), {
      required: true,
    }),
  },
  {
    name: 'description',
    label: i18n('entities.documentCategory.fields.description'),
    schema: schemas.string(i18n('entities.documentCategory.fields.description'), {}),
  },
];
